<template>
  <div :class="skillsAndToolsPageClass">
    <div v-for="(project, i) in projects" :key="i" :class="cardWrapperClass">
      <v-card class="card">
        <v-img :src="project.img" class="card-image" contain />
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkillsAndToolsPage",

  data() {
    return {
      projects: [
        {
          img: require("@/assets/vuejs.png"),
        },
        {
          img: require("@/assets/nodejs.png"),
        },
        {
          img: require("@/assets/javascript.png"),
        },
        {
          img: require("@/assets/github.png"),
        },
      ],
    };
  },

  computed: {
    skillsAndToolsPageClass() {
      return this.$vuetify.breakpoint.smAndDown
        ? "skills-and-tools-page-block"
        : "skills-and-tools-page-flex";
    },
    cardWrapperClass() {
      return this.$vuetify.breakpoint.smAndDown ? "card-block" : "card-flex";
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
